import React, { useState } from "react";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import ClContent from "../../components/CustomerList-comp/CLContent";
import "./CustomerList.css";
import ClContentNavigation from "../../components/CustomerList-comp/CLContentNavigation";

const CustomerList = () => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div className="col-md-12 content">
      <Sidebar
        className="sidebar-main"
        isActive={isActive}
        setIsActive={setIsActive}
        classNameTwo="open-sidebar"
      />
      <div className="col-12 sb-content">
        <div className="sb-content-header">
          <Header setIsActive={setIsActive} />
        </div>
        <div className="sb-nav">
          <ClContentNavigation />
        </div>
        <div className="content-index">
          <ClContent />
        </div>
      </div>
    </div>
  );
};

export default CustomerList;
